function ___$insertStyle(css) {
  if (!css) {
    return;
  }

  if (typeof window === 'undefined') {
    return;
  }

  var style = document.createElement('style');
  style.setAttribute('type', 'text/css');
  style.innerHTML = css;
  document.head.appendChild(style);
  return css;
}

import { __rest, __assign } from 'tslib';
import { createElement, useState, useRef } from 'react';
import useOnClickOutside from 'use-onclickoutside';
import Dayjs from 'dayjs';
import { MdDateRange } from '@react-icons/all-files/md/MdDateRange';
import { convertToHebrew, IsJewishDatesEqual, getPrevMonth, getJewishMonths, getJewishYears, getNextMonth, getJewishMonth, getJewishDay, getWeekdays, isValidDate, getGregDate } from 'jewish-dates-core';
import isBetween from 'dayjs/plugin/isBetween';

___$insertStyle(".reactJewishDatePicker {\n  --color: #333;\n  --backgroundColor: #e6e6e6;\n  position: relative;\n  display: grid;\n  font-family: arial;\n  margin-bottom: 5px;\n  cursor: pointer;\n}\n.reactJewishDatePicker .selectedDate {\n  padding: 2px 15px 2px 5px;\n  border: 1px solid var(--color);\n  border-radius: 4px;\n  user-select: none;\n  min-height: 20px;\n  text-align: center;\n  position: relative;\n  font-size: smaller;\n}\n.reactJewishDatePicker .calendarIcon {\n  font-size: 16px;\n  position: absolute;\n  right: 5px;\n  top: 4px;\n}\n.reactJewishDatePicker .monthWrapper {\n  background-color: #fff;\n  border: 1px solid #d6d9dd;\n  border-radius: 5px;\n  position: absolute;\n  top: 32px;\n  z-index: 1;\n  display: grid;\n  transform: scaleY(0);\n  transform-origin: top;\n  transition: transform 0.26s ease;\n  transition: max-height 0.5s ease-out;\n  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.175);\n  transition: all 0.4s ease-in-out;\n}\n.reactJewishDatePicker .monthWrapper.open {\n  transform: scaleY(1);\n}\n.reactJewishDatePicker.isHebrew {\n  direction: rtl;\n}\n.reactJewishDatePicker.isHebrew .startDay {\n  background: cornflowerblue;\n  border-radius: 0 7px 7px 0;\n  color: #fff;\n  margin: 1px 0;\n}\n.reactJewishDatePicker.isHebrew .endDay {\n  background: cornflowerblue;\n  border-radius: 7px 0 0 7px;\n  color: #fff;\n  margin: 1px 0;\n}\n.reactJewishDatePicker.isHebrew .weekday,\n.reactJewishDatePicker.isHebrew .day {\n  font-size: 16px;\n  padding: 0;\n}\n.reactJewishDatePicker .navigation {\n  display: grid;\n  grid-template-columns: 22px 138px 22px;\n  justify-content: space-between;\n  height: 22px;\n  padding: 5px;\n}\n.reactJewishDatePicker .navigation .arrowRight,\n.reactJewishDatePicker .navigation .arrowLeft {\n  display: grid;\n  align-items: center;\n  justify-content: center;\n}\n.reactJewishDatePicker .navigation .arrowRight span,\n.reactJewishDatePicker .navigation .arrowLeft span {\n  border: solid black;\n  border-width: 0 2px 2px 0;\n  padding: 1px;\n  transform: rotate(-45deg);\n  -webkit-transform: rotate(-45deg);\n  cursor: pointer;\n  width: 6px;\n  height: 6px;\n}\n.reactJewishDatePicker .navigation .arrowRight:hover,\n.reactJewishDatePicker .navigation .arrowLeft:hover {\n  background-color: var(--backgroundColor);\n}\n.reactJewishDatePicker .navigation .arrowLeft span {\n  transform: rotate(135deg);\n  -webkit-transform: rotate(135deg);\n}\n.reactJewishDatePicker .navigation .monthYearSelection {\n  display: grid;\n  grid-template-columns: auto auto;\n}\n.reactJewishDatePicker .navigation .monthYearSelection select {\n  border: 0px;\n  outline: 0px;\n}\n.reactJewishDatePicker .navigation .monthYearSelection select:hover {\n  cursor: pointer;\n  background-color: var(--backgroundColor);\n}\n.reactJewishDatePicker .navigation .monthYearSelection option {\n  background-color: #fff;\n}\n.reactJewishDatePicker.isHebrew .navigation .arrowLeft span {\n  transform: rotate(-45deg);\n  -webkit-transform: rotate(-45deg);\n}\n.reactJewishDatePicker.isHebrew .navigation .arrowRight span {\n  transform: rotate(135deg);\n  -webkit-transform: rotate(135deg);\n}\n.reactJewishDatePicker .month {\n  color: var(--color);\n  grid-template-columns: repeat(7, 1fr);\n  z-index: 2;\n  background-color: white;\n  display: grid;\n  width: 250px;\n  height: 180px;\n  border-radius: 5px;\n  padding: 2px;\n  text-align: center;\n}\n.reactJewishDatePicker .weekdayWrapper {\n  display: grid;\n  grid-template-columns: repeat(7, 1fr);\n  background-color: #001476;\n  padding: 2px;\n}\n.reactJewishDatePicker .weekday,\n.reactJewishDatePicker .day {\n  display: grid;\n  margin: 1px;\n  padding: 1px 1px 0 0;\n  align-items: center;\n  justify-content: center;\n  user-select: none;\n  border-radius: 7px;\n  cursor: pointer;\n  font-size: 14px;\n}\n.reactJewishDatePicker .day:hover {\n  background-color: var(--backgroundColor);\n}\n.reactJewishDatePicker .weekday {\n  color: #fff;\n  font-weight: bold;\n}\n.reactJewishDatePicker .otherMonth {\n  background: #fff;\n  color: #777;\n}\n.reactJewishDatePicker .selectedDay {\n  background: cornflowerblue;\n  color: #fff;\n}\n.reactJewishDatePicker .startDay {\n  background: cornflowerblue;\n  border-radius: 7px 0 0 7px;\n  color: #fff;\n  margin: 1px 0;\n}\n.reactJewishDatePicker .isInRange {\n  background-color: #91b6fa;\n  color: #fff;\n  border-radius: 0;\n  margin: 1px 0;\n}\n.reactJewishDatePicker .endDay {\n  background: cornflowerblue;\n  border-radius: 0 7px 7px 0;\n  color: #fff;\n  margin: 1px 0;\n}\n.reactJewishDatePicker .startDay:hover, .reactJewishDatePicker .isInRange:hover, .reactJewishDatePicker .endDay:hover {\n  background: cornflowerblue;\n}\n.reactJewishDatePicker .noSelect {\n  cursor: not-allowed !important;\n  background-color: #f3f3f3;\n}\n.reactJewishDatePicker .noSelect:hover {\n  background-color: #f3f3f3;\n}\n.reactJewishDatePicker .noSelect:active {\n  pointer-events: none;\n}");

var isFromTest = function isFromTest() {
  var _a;

  return typeof process !== 'undefined' && ((_a = process.env) === null || _a === void 0 ? void 0 : _a.JEST_WORKER_ID) !== undefined;
};

var getTestID = function getTestID(testId) {
  return isFromTest() ? testId : undefined;
};

var dayjs = Dayjs;
dayjs.extend(isBetween);

var isInRange = function isInRange(date, startDay, endDay) {
  if (startDay && endDay) {
    var start = dayjs(startDay.date);
    var end = dayjs(endDay.date);
    return dayjs(date).isBetween(start, end);
  }

  return false;
};

var isStartDay = function isStartDay(date, startDay) {
  if (startDay) {
    var start = dayjs(startDay.date).startOf('d');
    return dayjs(date).startOf('d').isSame(start);
  }

  return false;
};

var isEndDay = function isEndDay(date, startDay, endDay) {
  if (endDay && startDay) {
    var day = dayjs(date).startOf('d');
    var start = dayjs(startDay.date).startOf('d');
    var end = dayjs(endDay.date).startOf('d');
    return day.isSame(end) && !day.isSame(start);
  }

  return false;
};

var Day = function Day(props) {
  var isHebrew = props.isHebrew,
      selectedDay = props.selectedDay,
      isCurrentMonth = props.isCurrentMonth,
      day = props.day,
      dayjsDate = props.dayjsDate,
      isRange = props.isRange,
      startDay = props.startDay,
      endDay = props.endDay,
      canSelect = props.canSelect,
      onClick = props.onClick,
      onMouseOver = props.onMouseOver,
      basicJewishDay = __rest(props, ["isHebrew", "selectedDay", "isCurrentMonth", "day", "dayjsDate", "isRange", "startDay", "endDay", "canSelect", "onClick", "onMouseOver"]);

  var handleClick = function handleClick() {
    props === null || props === void 0 ? void 0 : props.onClick(basicJewishDay);
  };

  var handleMouseOver = function handleMouseOver() {
    (props === null || props === void 0 ? void 0 : props.onMouseOver) && (props === null || props === void 0 ? void 0 : props.onMouseOver(basicJewishDay));
  };

  var dayToDisplay = isHebrew ? convertToHebrew(day, false, false) : day;
  var title = props.isHebrew ? props.jewishDateStrHebrew : props.jewishDateStr;
  var otherMonthClass = !isCurrentMonth ? " otherMonth" : "";
  var selectedDayClass = selectedDay && (IsJewishDatesEqual(props.jewishDate, selectedDay.jewishDate) ? " selectedDay" : "");
  var disableSelectClass = canSelect && !canSelect(basicJewishDay) ? " noSelect" : "";
  var isInRangClass = isInRange(props.date, startDay, endDay) ? " isInRange" : "";
  var isStartDayClass = isStartDay(props.date, startDay) ? " startDay" : "";
  var isEndDayClass = isEndDay(props.date, startDay, endDay) ? " endDay" : "";
  var classNames = "day".concat(otherMonthClass).concat(selectedDayClass || "").concat(disableSelectClass).concat(isInRangClass).concat(isStartDayClass).concat(isEndDayClass);
  return createElement("div", {
    "data-testid": isFromTest() ? title : undefined,
    "data-date": props.date,
    className: classNames,
    title: title,
    onClick: handleClick,
    onMouseOver: handleMouseOver
  }, dayToDisplay);
};

var Weekday = function Weekday(props) {
  return createElement("div", {
    className: "weekday"
  }, props.value);
};

var Navigation = function Navigation(props) {
  return createElement("div", {
    className: "navigation"
  }, createElement("div", {
    className: "arrowLeft",
    "data-testid": getTestID('prev'),
    onClick: function onClick() {
      var basicJewishMonthInfo = getPrevMonth({
        month: props.month,
        year: props.year,
        isHebrew: props.isHebrew
      });
      props.onClick(basicJewishMonthInfo.month, basicJewishMonthInfo.year);
    }
  }, createElement("span", null)), createElement("div", {
    className: "monthYearSelection"
  }, createElement("select", {
    "data-testid": getTestID('month'),
    value: props.month,
    onChange: function onChange(e) {
      var month = e.currentTarget.value;
      props.onClick(month, props.year);
    }
  }, getJewishMonths(props.year, props.isHebrew).map(function (month) {
    return createElement("option", {
      "data-testid": getTestID(month.text),
      key: month.id,
      value: month.id
    }, month.text);
  })), createElement("select", {
    "data-testid": getTestID('year'),
    value: props.year,
    onChange: function onChange(e) {
      var year = Number(e.currentTarget.value);
      props.onClick(props.month, year);
    }
  }, getJewishYears(props.year).map(function (y) {
    var text = props.isHebrew ? convertToHebrew(y) : y;
    return createElement("option", {
      "data-testid": getTestID(y.toString()),
      key: y,
      value: y
    }, text);
  }))), createElement("div", {
    className: "arrowRight",
    "data-testid": getTestID('next'),
    onClick: function onClick() {
      var basicJewishMonthInfo = getNextMonth({
        month: props.month,
        year: props.year,
        isHebrew: props.isHebrew
      });
      props.onClick(basicJewishMonthInfo.month, basicJewishMonthInfo.year);
    }
  }, createElement("span", null)));
};

var getDatesInOrder = function getDatesInOrder(day1, day2) {
  if (day1 && day2) {
    return Dayjs(day1.date).isBefore(Dayjs(day2.date)) ? [day1, day2] : [day2, day1];
  } else {
    return [];
  }
};

var getDateStringForSelectedDay = function getDateStringForSelectedDay(isRange, isHebrew, selectedDay, startDay, endDay) {
  if (isRange) {
    if (startDay === null || startDay === void 0 ? void 0 : startDay.jewishDateStrHebrew) {
      return isHebrew ? "".concat(startDay === null || startDay === void 0 ? void 0 : startDay.jewishDateStrHebrew, " - ").concat((endDay === null || endDay === void 0 ? void 0 : endDay.jewishDateStrHebrew) || '') : "".concat(startDay === null || startDay === void 0 ? void 0 : startDay.jewishDateStr, " - ").concat((endDay === null || endDay === void 0 ? void 0 : endDay.jewishDateStr) || '');
    } else {
      return isHebrew ? 'בחר תאריכים' : 'Pick Dates';
    }
  } else if (selectedDay) {
    return isHebrew ? selectedDay.jewishDateStrHebrew : selectedDay.jewishDateStr;
  } else {
    return isHebrew ? 'בחר תאריך' : 'Pick Date';
  }
};

var isDateRange = function isDateRange(object) {
  if (object === void 0) {
    object = {};
  }

  return 'startDate' in object;
};

var getDateInit = function getDateInit(date) {
  if (isDateRange(date)) {
    return isValidDate(date.startDate) ? date.startDate : getGregDate(date.startDate);
  } else {
    return isValidDate(date) ? date : getGregDate(date);
  }
};

var ReactJewishDatePicker = function ReactJewishDatePicker(props) {
  var className = props.className,
      value = props.value,
      isHebrew = props.isHebrew,
      isRange = props.isRange,
      onClick = props.onClick,
      canSelect = props.canSelect;

  if (typeof value == 'string') {
    throw new Error("ReactJewishDatePicker: The value can be BasicJewishDate or Date. for Dates use 'value={new Date()}' not 'value={Date()}");
  } // const month = getJewishMonth(new Date("2020-05-24"));


  var dateInit = value ? getDateInit(value) : new Date();
  var endDateInit = isDateRange(value) && getDateInit(value.endDate);

  var _a = useState(dateInit),
      date = _a[0],
      setDate = _a[1];

  var jewishMonth = getJewishMonth(date);

  var _b = useState(!isRange && value && jewishMonth.selectedDay),
      selectedDay = _b[0],
      setSelectedDay = _b[1];

  var _c = useState(isRange && isDateRange(value) && jewishMonth.selectedDay),
      startDay = _c[0],
      setStartDay = _c[1];

  var _d = useState(isRange && isDateRange(value) && getJewishDay(Dayjs(endDateInit))),
      endDay = _d[0],
      setEndDay = _d[1];

  var _e = useState(false),
      isOpen = _e[0],
      setOpen = _e[1];

  var _f = useState(null),
      hoveredDay = _f[0],
      setHoveredDay = _f[1];

  var ref = useRef(null);
  useOnClickOutside(ref, function () {
    setOpen(false);
  });

  var handleClick = function handleClick(day) {
    if (isRange) {
      if (!startDay || endDay) {
        setStartDay(day);
        setEndDay(null);
      } else {
        var _a = getDatesInOrder(startDay, day),
            start_1 = _a[0],
            end_1 = _a[1];

        setStartDay(start_1);
        setEndDay(end_1);
        props === null || props === void 0 ? void 0 : props.onClick(start_1, end_1);
        setOpen(!isOpen);
      }
    } else {
      setSelectedDay(day);
      props === null || props === void 0 ? void 0 : props.onClick(day, undefined);
      setOpen(!isOpen);
    }
  };

  var handleMouseOver = function handleMouseOver(day) {
    setHoveredDay(day);
  };

  var setBasicJewishDate = function setBasicJewishDate(basicJewishDate) {
    var gregDate = getGregDate(basicJewishDate);
    setDate(gregDate);
  };

  var handleNavigationClick = function handleNavigationClick(month, year) {
    var basicJewishDate = {
      year: year,
      monthName: month,
      day: jewishMonth.selectedDay.day
    };
    setBasicJewishDate(basicJewishDate);
  };

  var _g = getDatesInOrder(startDay, hoveredDay),
      start = _g[0],
      end = _g[1];

  var classNames = "reactJewishDatePicker".concat(isHebrew ? " isHebrew" : '', " ").concat(className || '');
  var selectedDaysToDisplay = getDateStringForSelectedDay(isRange, isHebrew, selectedDay, startDay, endDay);
  return createElement("div", {
    ref: ref,
    className: classNames
  }, createElement("div", {
    "data-testid": getTestID('selectedDate'),
    onClick: function onClick() {
      return setOpen(!isOpen);
    },
    className: "selectedDate"
  }, createElement(MdDateRange, {
    className: "calendarIcon"
  }), selectedDaysToDisplay), createElement("div", {
    className: "monthWrapper ".concat(isOpen ? "open" : "")
  }, createElement(Navigation, {
    month: jewishMonth.jewishMonthString,
    year: jewishMonth.jewishYear,
    isHebrew: isHebrew,
    onClick: handleNavigationClick
  }), createElement("div", {
    className: 'weekdayWrapper'
  }, getWeekdays(isHebrew).map(function (weekday, index) {
    return createElement(Weekday, {
      key: index,
      value: weekday
    });
  })), createElement("div", {
    className: "month"
  }, jewishMonth.days.map(function (day, index) {
    return createElement(Day, __assign({
      key: index
    }, day, {
      canSelect: canSelect,
      onClick: handleClick,
      onMouseOver: isRange && handleMouseOver,
      selectedDay: selectedDay,
      isRange: isRange,
      isHebrew: isHebrew,
      startDay: !endDay ? start : startDay,
      endDay: endDay || end
    }));
  }))));
};

ReactJewishDatePicker.defaultProps = {
  isHebrew: false
};
export { ReactJewishDatePicker };